$(document).ready(function() {
  if (document.body.scrollHeight <= window.innerHeight) {
    $('.mobile-dock').addClass('active');
  }
  const main = document.querySelector('[role="main"]');
  if (main) {
    const firstSection = main.querySelector('.shopify-section');
    if (firstSection) {
      firstSection.setAttribute('is-first', '');
    }
  }
});